import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import api from './utils/api';
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.prototype.$api = api;

Vue.config.productionTip = false

window.agentType = 0;

// alert(location.hostname)
let hostname = location.hostname;
if (hostname == "xm.buercamp.com" || hostname == "miadmin.felixtech.cn") {
  window.channel = "xm";
  window.request_host = "https://miapi.felixtech.cn"
  // window.request_host = "https://mi.91mgame.com:8443"
  window.ad_host = "https://xiaomi.buercamp.com"
  window.update_host = "https://update.buercamp.com"
} else if (hostname == "xiaomi.311419.com") {
  window.channel = "fzxm";
  window.request_host = "https://xmapi.311419.com"
  window.ad_host = "https://xiaomi.311419.com" 
  window.update_host = "https://update.311419.com"
} else if (hostname == "localhost" || hostname == "xm.cloudyproxy.com") {
  window.channel = "xm";
  window.request_host = "https://xmapi.cloudyproxy.com"
  // window.request_host = "https://mi.91mgame.com:8443"
  window.ad_host = "https://xiaomi.cloudyproxy.com"
  window.update_host = "https://update.buercamp.com"

  // window.channel = "chuanyin";
  // window.request_host = "https://cyapi.felixtech.cn"
  // window.ad_host = "https://cyad.felixtech.cn"
  // window.update_host = "https://update.buercamp.com"
  // document.querySelector("link[rel=icon]").href = "https://transsion.com/favicon.ico";

  // window.channel = "xm";
  // window.request_host = "https://miapi.felixtech.cn"
  // // window.request_host = "https://mi.91mgame.com:8443"
  // window.ad_host = "https://xiaomi.buercamp.com"
  // window.update_host = "https://update.buercamp.com"

  // window.ad_host = "http://127.0.0.1:1419"


  // window.channel = "vivo";
  // window.request_host = "https://viapi.felixtech.cn"
  // window.ad_host = "https://viad.felixtech.cn"
  // window.update_host = "https://update.buercamp.com"
  // document.querySelector("link[rel=icon]").href = require("@/assets/vivo_logo.png");
  
  // window.channel = "oppo";
  // window.request_host = "https://opapi.felixtech.cn"
  // window.ad_host = "https://opad.felixtech.cn"
  // window.update_host = "https://opupdate.felixtech.cn"
  // document.querySelector("link[rel=icon]").href = "https://www.oppo.com/jimu/oppo-site/resources/images/favicon.ico";

  // window.channel = "tiktok";
  // window.request_host = "https://ttapi.felixtech.cn"
  // window.ad_host = "https://ttad.felixtech.cn"


  window.agentType = 1;
  window.channel = "oppo";
  window.request_host = "https://opadminapi.311419.com"
  window.ad_host = "https://opad.311419.com"
  window.update_host = "https://adupdate.311419.com"
  document.querySelector("link[rel=icon]").href = "https://www.oppo.com/jimu/oppo-site/resources/images/favicon.ico";
  
} else if (hostname == "opadmin.felixtech.cn") {
  window.channel = "oppo";
  window.request_host = "https://opadminapi.felixtech.cn"
  window.ad_host = "https://opad.felixtech.cn"
  window.update_host = "https://opupdate.felixtech.cn"
  document.querySelector("link[rel=icon]").href = "https://www.oppo.com/jimu/oppo-site/resources/images/favicon.ico";
} else if (hostname == "cyadmin.felixtech.cn") {
  window.channel = "chuanyin";
  window.request_host = "https://cyapi.felixtech.cn"
  window.ad_host = "https://cyad.felixtech.cn"
  window.update_host = "https://update.buercamp.com"
  document.querySelector("link[rel=icon]").href = "https://transsion.com/favicon.ico";
} else if (hostname == "viadmin.felixtech.cn") {
  window.channel = "vivo";
  window.request_host = "https://viapi.felixtech.cn"
  window.ad_host = "https://viad.felixtech.cn"
  window.update_host = "https://update.buercamp.com"
  document.querySelector("link[rel=icon]").href = require("@/assets/vivo_logo.png");
} else if (hostname == "ttadmin.felixtech.cn") {
  window.channel = "tiktok";
  window.request_host = "https://ttapi.felixtech.cn"
  window.ad_host = "https://ttad.felixtech.cn"
  // window.update_host = "https://update.buercamp.com"
  document.querySelector("link[rel=icon]").href = require("@/assets/tiktok.png");
} 
else if (hostname == "opadmin.311419.com") {
  window.agentType = 1;
  window.channel = "oppo";
  window.request_host = "https://opadminapi.311419.com"
  window.ad_host = "https://opad.311419.com"
  window.update_host = "https://adupdate.311419.com"
  document.querySelector("link[rel=icon]").href = "https://www.oppo.com/jimu/oppo-site/resources/images/favicon.ico";
}
else if (hostname == "viadmin.311419.com") {
  window.agentType = 2;
  window.channel = "vivo";
  window.request_host = "https://viadminapi.311419.com"
  window.ad_host = "https://viad.311419.com"
  window.update_host = "https://adupdate.311419.com"
  document.querySelector("link[rel=icon]").href = require("@/assets/vivo_logo.png");
}
else if (hostname == "miadmin.311419.com") {
  window.agentType = 3;
  window.channel = "xm";
  window.request_host = "https://miadminapi.311419.com"
  window.ad_host = "https://miad.311419.com"
  window.update_host = "https://adupdate.311419.com"
}

// window.channel = "xm"
// if (window.channel == "fzxm") {
//   window.request_host = "https://xmapi.311419.com"
//   window.ad_host = "https://xiaomi.311419.com"
//   window.update_host = "https://update.311419.com"
// } else if (window.channel == "xm") {
//   window.request_host = "https://xmapi.cloudyproxy.com"
//   window.ad_host = "https://xiaomi.cloudyproxy.com"
//   window.update_host = "https://update.buercamp.com"
// } else if (window.channel == "test") {
//   window.request_host = "http://127.0.0.1:8060";
//   window.ad_host = "http://127.0.0.1:8060";
//   window.update_host = "http://127.0.0.1:8060"
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
